import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = ({ logo, buttons }) => {
  const navigate = useNavigate(); // For navigation

  return (
    <header className="flex items-center justify-between p-4 bg-white shadow-gray-700 shadow-xl flex-wrap">
      {/* Logo */}
      {/* <img src={logo} alt="Logo" className="h-20" /> */}
      <img src={logo} alt="Logo" className="h-20" />

      {/* Dynamic Buttons */}
      <div className="flex gap-4">
        {buttons.map((button, index) => (
          <button
            key={index}
            onClick={() => {
              if (button.onClick) {
                button.onClick(); // Call function if provided
              } else {
                navigate(button.route); // Default navigation
              }
            }}
            className={`px-4 py-2 rounded-md font-medium transition ${button.color} hover:opacity-80`}
          >
            {button.text}
          </button>
        ))}
      </div>
    </header>
  );
};

export default Header;
